import { get } from '@Green-Dot-Corporation/eureka-lib-fetch-utils';

// Utils
import {
    getApiUrlWithEnv,
    normalizeResponse,
    getSubscriptionKeyByEnv,
} from '../utils/serviceUtils';

// Constants
import { HEADERS_AND_PARAMS } from '../const/apis';

export const getAuthorizationToken = async (params) => {
    const { code, accountIdentifier, requestId, programCode, sign } =
        params ?? {};
    const response = await get(
        `${getApiUrlWithEnv()}/api/${accountIdentifier}/token`,
        {
            headers: {
                [HEADERS_AND_PARAMS.REQUEST_ID]: requestId,
                [HEADERS_AND_PARAMS.PROGRAM_CODE]: programCode,
                [HEADERS_AND_PARAMS.CODE]: code,
                [HEADERS_AND_PARAMS.SIGN]: sign,
                [HEADERS_AND_PARAMS.ACCOUNT_IDENTIFIER]: accountIdentifier,
                [HEADERS_AND_PARAMS.SUBSCRIPTION_KEY]:
                    getSubscriptionKeyByEnv(),
            },
        },
    );

    return normalizeResponse(response);
};

export default {};
